/**
 * Extracts a human-readable error message from an axios error response.
 * Handles all backend error shapes:
 *   - string detail: "Email already registered"
 *   - array (Pydantic validation): [{msg: "..."}, {msg: "..."}]
 *   - object: {detail: "..."}
 *   - network errors / unknown
 */
export const parseApiError = (error, fallback = 'Une erreur est survenue') => {
  // No response from server (network / CORS / offline)
  if (!error?.response) {
    if (error?.message) return `Réseau : ${error.message}`;
    return fallback;
  }

  const data = error.response.data;
  if (!data) return fallback;

  // Pydantic validation : detail is an array of {msg, loc, type}
  if (Array.isArray(data.detail)) {
    return data.detail
      .map(d => {
        if (typeof d === 'string') return d;
        if (d && typeof d.msg === 'string') {
          const field = Array.isArray(d.loc) ? d.loc.filter(x => x !== 'body').join('.') : '';
          return field ? `${field} : ${d.msg}` : d.msg;
        }
        return JSON.stringify(d);
      })
      .join(' · ');
  }

  // Common shapes
  if (typeof data.detail === 'string') return data.detail;
  if (typeof data.message === 'string') return data.message;
  if (typeof data.error === 'string') return data.error;

  // HTTP status fallback
  if (error.response.status) {
    return `Erreur HTTP ${error.response.status}`;
  }

  return fallback;
};
